import { Alert, Box, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages as messages } from './tiktok-disclosure-messages';
import { TiktokDisclosureCheckboxes } from './TiktokDisclosureCheckboxes';
import { TiktokDisclosureLegalText } from './TiktokDisclosureLegalText';
import { TiktokDisclosureToggleRow } from './TiktokDisclosureToggleRow';
import { useTiktokDisclosureState } from './useTiktokDisclosureState';

/**
 * TikTok disclosure settings block.
 * Renders the "Disclose video content" toggle (form-only; not sent to API). When on,
 * shows an alert (only when at least one checkbox is selected), helper description,
 * then "Your brand" and "Branded content" checkboxes. At least one must be selected to submit.
 * Prompt text in the alert reflects the selected option(s) per TikTok guidelines.
 */
export function TiktokDisclosureSettings() {
  const { $t } = useIntl();
  const {
    isDisclosureOn,
    noneSelected,
    hasBrandedContent,
    hasBrandedContentPrivacyConflict,
    alertMessage,
  } = useTiktokDisclosureState();

  return (
    <Stack spacing={2}>
      <TiktokDisclosureToggleRow enabled={isDisclosureOn} />

      {isDisclosureOn && (
        <>
          {!noneSelected && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Alert severity="info">{alertMessage}</Alert>
            </Box>
          )}

          {isDisclosureOn && (
            <Typography variant="body2" color="text.secondary">
              {$t(messages.disclosureDescription)}
            </Typography>
          )}

          <TiktokDisclosureCheckboxes />

          <TiktokDisclosureLegalText hasBrandedContent={hasBrandedContent} />

          {hasBrandedContentPrivacyConflict && (
            <Alert severity="warning">{$t(messages.brandedContentVisibility)}</Alert>
          )}
        </>
      )}
    </Stack>
  );
}
